// must be all lower case, see getUserCumulRole for more info
export enum CumulRole {
  OWNER = "owner",
  VIEWER = "viewer",
  DESIGNER = "designer",
}
